import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { initialReportLock } from './report_lock'

const state = {
  user: undefined,
  abilities: undefined,
  consultant_level: undefined,
  report_pendencies: undefined,
  company_pendencies_viewed: false,
  announcement_notifications: undefined,
  pn_onboarding_status: null,
  // Trava de report pendente — espelho do servidor (GET /api/users/report_pendencies e 423 da API).
  // Nunca é a fonte da verdade: só evita abrir telas que o servidor recusaria.
  reportLock: initialReportLock(),
}

export default {
  state,
  actions,
  getters,
  mutations
}
